<template>
    <div>
        <el-dialog class="el-dialog_wrapper" :visible.sync="cancelVisible" @close="cancel" :close-on-click-modal="false">
            <div slot="title" class="dialog-head">
                <span class="head-title">FPX Transaction</span>
            </div>
            <div class="dialog-body">
                <span class="message-c">{{message}}</span>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button type="danger" :disabled="buttonAble" @click="cancelTran">Yes </el-button>
                <el-button type="danger" @click="cancel">No</el-button>
            </div>
        </el-dialog>
    </div>
</template>


<script>
    export default {
        name: 'CancelDialog',
        props: {
            cancelVisible: {
                type: Boolean,
                default: false
            },
            buttonAble: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                message: 'Do you want to cancel this transaction?',
            }
        },

        methods: {
            cancelTran() {
                this.$emit("cancelTran");
            },
            cancel() {
                this.$emit("cancelDialogClose", false);
            }
        }
    };
</script>

<style lang="less" scoped>
    @media screen and (max-width: 370px) {
        @import "../styles/mobile/m_dialog-cancel.less";
    }

    @media screen and (min-width: 371px) and (max-width: 400px) {
        @import "../styles/mobile_b/m_dialog-cancel.less";
    }

    @media screen and (min-width: 401px) and (max-width: 640px) {
        @import "../styles/mobile_p/m_dialog-cancel.less";
    }

    @media screen and (min-width: 641px) and (max-width: 800px) {
        @import "../styles/pad/dialog-cancel.less";
    }

    @media screen and (min-width: 801px) and (max-width: 1200px) {
        @import "../styles/pad_pro/dialog-cancel.less";
    }

    @media screen and (min-width: 1201px) {
        @import "../styles/pc/dialog-cancel.less";
    }
</style>


// WEBPACK FOOTER //
// src/views/DialogCancel.vue